// LandingPage.js
import React from 'react';
import HeroSection from '../Components/HeroSection';
import Features from '../Components/Features';
import Testimonials from '../Components/Testimonials';
import Pricing from '../Components/Pricing';
import Footer from '../Components/Footer';

const LandingPage = () => (
  <>
    <Features />
    <Testimonials />
    <Footer />
  </>
);

export default LandingPage;
